<template>
    <div class="pageClass">
        <div id="loading" v-if="showLoading">
            <img class="loadingImg" src="../../assets/loading.gif" alt="loading..." width="200" />
        </div>
        <NavBar></NavBar>
        <div class="container-fluid p-2">
            <div class="d-flex justify-content-around SearchCondition row">
                <div class="col-12 col-md-6">
                    <img src="../../assets/Hinee.png" width="100" />
                    <span>{{ $t('CheckDeviceTest.DeviceInspectionResults') }}：{{ CheckResult }}</span>
                </div>
                <div class="col-12 col-md-6">
                    <span style="float: right;">
                        <button class="ShareBTN" style="
                                margin-right: 5px;
                                background:  #51dcef;
                                color: #212529;" @click="ReEnter()">
                            <font-awesome-icon icon="fa-sharp fa-light fa-door-open" />
                            <span>{{ $t('CheckDeviceTest.EnterClassroom') }}</span>
                        </button>
                        <button class="ShareBTN" @click="ReCheck()">
                            <font-awesome-icon icon="fa-sharp fa-light fa-rotate-right" />
                            <span>{{ $t('CheckDeviceTest.Reload') }}</span>
                        </button>
                        <button class="ShareBTN" style="
                                background:  rgb(229, 0, 18);
                                color: #fff;" @click="DeviceTest()" v-if="showDeviceTestBtn">
                            <font-awesome-icon icon="fa-sharp fa-light fa-wrench" />
                            <span>{{ $t('CheckDeviceTest.DeviceTesting') }}</span>
                        </button>
                        <button class="ShareBTN" style="
                                width: 130px;
                                height: 40px;
                                color: #221714;
                                font-size: 18px;
                                background: #feb000;
                                border-radius: 10px;" @click="EnterClassroom()" v-if="showEnterClassroom">
                            <font-awesome-icon icon="fa-sharp fa-light fa-right-to-bracket" /><span>{{ $t('CheckDeviceTest.EnterClassroom') }}</span>
                        </button>
                    </span>
                </div>
                <!-- <div class="col-12 col-md-4"  >
                    <span style="float: right;"> -->
                <!-- <button class="ShareBTN" style="
                                width: 130px;
                                height: 40px;
                                color: #221714;
                                font-size: 18px;
                                background: #feb000;
                                border-radius: 10px;" @click="EnterClassroom()" v-if="showEnterClassroom">
                                <font-awesome-icon icon="fa-sharp fa-light fa-right-to-bracket" /><span>{{ $t('CheckDeviceTest.EnterClassroom') }}</span></button> -->
                <!-- </span>
                </div> -->
            </div>
            <table class="table AttendanceTable p-2 table-rwd table-bordered" v-if="RecordObjects.length > 0">
                <thead>
                    <tr class="tr-only-hide">
                        <th scope="col"></th>
                        <th scope="col">{{ $t('CheckDeviceTest.Device') }}</th>
                        <th scope="col">{{ $t('CheckDeviceTest.Browser') }}</th>
                        <th scope="col">{{ $t('CheckDeviceTest.Earphones') }}</th>
                        <th scope="col">{{ $t('CheckDeviceTest.Microphone') }}</th>
                        <th scope="col">{{ $t('CheckDeviceTest.Webcam') }}</th>
                        <!-- <th scope="col">{{ $t('CheckDeviceTest.Network') }}</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="Record in RecordObjects">
                        <td data-th="">{{ Record.Type }}</td>
                        <td v-if="Record.Model[0]" data-th="使用設備"><font-awesome-icon :icon="Record.Model[1]" :style="{ color: Record.Model[2] }" /></td>
                        <td v-else data-th="使用設備">{{ Record.Model[1] }}</td>
                        <td v-if="Record.Browser[0]" data-th="瀏覽器"><font-awesome-icon :icon="Record.Browser[1]" :style="{ color: Record.Browser[2] }" /></td>
                        <td v-else data-th="瀏覽器">{{ Record.Browser[1] }}</td>
                        <td v-if="Record.Audio[0]" data-th="耳機"><font-awesome-icon :icon="Record.Audio[1]" :style="{ color: Record.Audio[2] }" /></td>
                        <td v-else data-th="耳機">{{ Record.Audio[1] }}</td>
                        <td v-if="Record.Mic[0]" data-th="麥克風"><font-awesome-icon :icon="Record.Mic[1]" :style="{ color: Record.Mic[2] }" /></td>
                        <td v-else data-th="麥克風">{{ Record.Mic[1] }}</td>
                        <td v-if="Record.Camera[0]" data-th="視訊"><font-awesome-icon :icon="Record.Camera[1]" :style="{ color: Record.Camera[2] }" /></td>
                        <td v-else data-th="視訊">{{ Record.Camera[1] }}</td>
                        <!-- <td v-if="Record.Net[0]" data-th="網路"><font-awesome-icon :icon="Record.Net[1]" :style="{ color: Record.Net[2]}" /></td>
                        <td v-else data-th="網路" >{{Record.Net[1]}}</td> -->
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-around SearchCondition row">
                <div class="col-12 col-md-8">
                    <p><font-awesome-icon icon="fa-sharp fa-light fa-check" style="color: #49f500;" />：{{ $t('CheckDeviceTest.NotificationSuccessful') }}</p>
                    <p><font-awesome-icon icon="fa-sharp fa-light fa-x" style="color: #ff0000;" />：{{ $t('CheckDeviceTest.NotificationFailed') }}</p>
                    <p> - ：{{ $t('CheckDeviceTest.NotificationNone') }}</p>
                    <!-- <p style="color: #ff0000; font-size: large;"> {{ $t('CheckDeviceTest.NotificationRevalidate') }}</p> -->
                </div>
            </div>
        </div>

        <!-- ShowMessageModal -->
        <div class="modal fade" id="ShowMessageModal" tabindex="-1" aria-labelledby="ShowMessageModalLabel">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body ">
                        <div>
                            <span id="MessageText">{{ Message }}</span><br />
                        </div>

                        <div>
                            <img id="DeviceCheckNoteImgTw" src="../../assets/DeviceCheckNoteTw.png" width="90%" />
                            <img id="DeviceCheckNoteImgEn" src="../../assets/DeviceCheckNoteEn.png" width="90%" />
                        </div>

                    </div>

                    <!-- <div class="modal-footer"></div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import axios from 'axios'
import moment from 'moment'
import $ from 'jquery'

import AgoraRTC from "agora-rtc-sdk-ng";

export default {
    name: 'CheckDeviceTest',
    // props: ['icon','style'],
    components: {
        NavBar
    },
    data() {
        return {
            PreClassDeviceTestingList: null,
            showLoading: false,
            showEnterClassroom: false,
            showDeviceTestBtn: true,
            CheckResult: this.$t('CheckDeviceTest.Failed'),
            RecordObjects: [
                {
                    ID: 1,
                    Type: this.$t('CheckDeviceTest.TestResults'),
                    Model: [true, ['fasl', 'xmark'], '#ff0000'],
                    Browser: [true, ['fasl', 'xmark'], '#ff0000'],
                    Audio: [true, ['fasl', 'xmark'], '#ff0000'],
                    Mic: [true, ['fasl', 'xmark'], '#ff0000'],
                    Camera: [false, '-'],
                    // Net : [true,['fasl', 'check'],'#49f500'],
                }, {
                    ID: 2,
                    Type: this.$t('CheckDeviceTest.CauseOfTheAbnormality'),
                    Model: [false, '-'],
                    Browser: [false, '-'],
                    Audio: [false, '-'],
                    Mic: [false, '-'],
                    Camera: [false, '-'],
                    // Net : [false,'-'],
                },
            ],
            fields: ["Model", "Browser", "Audio", "Mic", "Camera", "Net"],
            //agora data
            agoraAxios: null,
            // agora本地客戶端
            agoraClient: null,
            // agora頻道用戶列表
            agoraVideoRemoteUsers: {},
            agoraAudioRemoteUsers: {},
            // agora音量範圍
            agoraVolumeRange: 50,
            // agora相關參數
            agoraData: {
                // appId
                agoraAppid: "4fb8c9d3b41f444990a632251b85e9c8",
                // 頻道號
                agoraChannel: sessionStorage.getItem('DClassroomId'),
                // 根據頻道號生成的token
                agoraToken: sessionStorage.getItem('DAgoraToken'),
                // agoraUID
                agoraUid: sessionStorage.getItem('DUserId'),
                // 攝像頭實例
                agoraCameraClient: null,
                // 攝像頭本地實例
                localCameraClient: null,
                // 音頻本地實例
                localMicrophoneClient: null,
                // 喇叭本地實例
                localPlaybackDeviceClient: null,
            },
            // 麥克風列表
            agoraMicrophoneList: [],
            agoraMicrophoneActive: [],
            // 攝像頭列表
            agoraCamerasList: [],
            agoraCamerasActive: [],
            // 喇叭列表
            agoraPlaybackDevicesList: [],
            agoraPlaybackDevicesActive: [],

            s_camera: "",
            s_mic: "",
            s_speaker: "",

            browser: "",
            Model: "",

            Message: "",

            //是否通過
            modelCheck: false,
            browserCheck: false,
            micCheck: false,
            cameraCheck: false,
            audioCheck: false,
            IsPassed: false,
            IsDesktop: false,

            PreClassDeviceTestingId: 0,
            classKey: null,

            ebseq: null,
            classroomUrl: null,

            PreClassDeviceTesting: []
        }
    },
    mounted() {
        this.SetAgora();
        this.DeviceTestSet();

        if (AgoraRTC.checkSystemRequirements()) {
            // agora初始化
            this.agoraInit()
            // 獲取媒體列表
            this.getMedia()
        } else {
            alert(this.$t('CheckDeviceTest.TheCurrentBrowserDoesNotSupportAgoraServices'))
        }
    },
    methods: {
        async SetAgora() {
            this.agoraAxios = axios.create({
                baseURL: 'https://agora-service.hi-tr.com'
            })
        },
        async DeviceTestSet() {
            // 获取agora的token
            const agoraTokenDataD = await this.agoraAxios.get(`/rtc/T` + sessionStorage.getItem('ClassroomId'))
            // 設置臨時的DeviceTest的 UserId channel token                
            sessionStorage.setItem('DUserId', sessionStorage.getItem('StudentUserId'));
            sessionStorage.setItem('DClassroomId', 'T' + sessionStorage.getItem('ClassroomId'));
            sessionStorage.setItem('DAgoraToken', agoraTokenDataD.data.rtcToken);

            await this.GetEbSeq();
            await sessionStorage.setItem('CustomerCode', this.ebseq);

            //當企業編號為99999(老師)且語系為空值時，強制切換至英文語系。
            if(localStorage.getItem("lang") == null && sessionStorage.getItem("CustomerCode") == "99999"){
                localStorage.setItem("lang", "en");
                location.reload();
                return ture;
            }

            await this.GetClassroomUrlByStudnet();
            await sessionStorage.setItem('ClassroomUrl', this.classroomUrl) 
        },
        async agoraInit() {
            // 獲取參數
            const agoraUid = '0' + this.agoraData.agoraUid
            const { agoraAppid, agoraChannel, agoraToken } = this.agoraData

            // 創建agora實例
            this.agoraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
            // 添加監聽事件 監聽用戶離開加入
            // this.agoraClient.on("user-published", this.agoraUserPublished);
            // this.agoraClient.on("user-unpublished", this.agoraUserUnpublished);
            // this.agoraClient.on("network-quality", this.setStartStop);
            // 加入頻道
            await this.agoraClient.join(agoraAppid, agoraChannel, agoraToken, Number(agoraUid));
        },
        async getMedia() {
            //debugger;
            // 獲取agora的麥克風列表
            this.agoraMicrophoneList = await AgoraRTC.getMicrophones()

            // // 獲取agora的攝像頭列表
            this.agoraCamerasList = await AgoraRTC.getCameras()

            console.log('this.agoraCamerasList', this.agoraCamerasList)

            // 獲取agora的麥克風列表
            if (this.isDesktop) {
                this.agoraPlaybackDevicesList = await AgoraRTC.getPlaybackDevices()
            }
            else 
            {
                this.agoraPlaybackDevicesList = this.agoraMicrophoneList;
            }

            console.log('this.agoraPlaybackDevicesList', this.agoraPlaybackDevicesList)

            await this.GetPreClassDeviceTesting();
        },
        //查詢設備紀錄
        async GetPreClassDeviceTesting() {
            this.showLoading = true;
            const api = `${process.env.APIPATH}/api/Student/GetPreClassDeviceTesting`;
            // const headers = {"Authorization": 'Bearer '+this.Token};
            const inputdata =
            {
                UserId: sessionStorage.getItem('StudentUserId'),
                Model: this.Model,
                Language: this.Language
            };

            await axios.post(api, inputdata)
                .then((response) => {
                    var Language = this.Language;

                    this.showLoading = false;
                    if (response.data.Result) {
                        console.log('response', response);

                        if (response.data.PreClassDeviceTesting.length != 0) {

                            const preClassDeviceTestingData = response.data.PreClassDeviceTesting;

                            // 或者使用循环打印所有记录
                            preClassDeviceTestingData.forEach((record, index) => {
                                this.PreClassDeviceTesting.push(record);
                                console.log(`Record ${index + 1}:`, record);
                            });

                            // this.PreClassDeviceTesting = response.data.PreClassDeviceTesting;
                            //判斷當前設備與DB儲存設備是否有差異
                            $('#DeviceCheckNoteImgTw').hide();
                            $('#DeviceCheckNoteImgEn').hide();
                            this.CheckDeiveAndAgora();
                        }
                        else 
                        {
                            this.browserCheck = this.Browser == 'Chrome';
                            this.SaveEntryRoomDeviceTestingResult();
                            //show Message Modal
                            //已驗證設備2組
                            if (response.data.Count == 2) {
                                this.showDeviceTestBtn = false;
                                this.Message = this.$t('CheckDeviceTest.PleaseSwitchToADeviceAndSetup');
                                $('#DeviceCheckNoteImgTw').hide();
                                $('#DeviceCheckNoteImgEn').hide();
                                $('#ShowMessageModal').modal('show');
                            }
                            else 
                            {
                                this.Message = response.data.Message;
                                $('#MessageText').css({
                                    color: 'red',
                                    'font-size': '20px'
                                });

                                if(Language == "En")
                                {
                                    //Show En Image
                                    $('#DeviceCheckNoteImgEn').show();
                                    $('#DeviceCheckNoteImgTw').hide();
                                }
                                else
                                {
                                    //Show Tw Image
                                    $('#DeviceCheckNoteImgTw').show();
                                    $('#DeviceCheckNoteImgEn').hide();
                                }

                                $('#ShowMessageModal').modal('show');
                            }
                        }
                    } else 
                    {
                        //
                    }
                })
                .catch(error => {
                    // this.RecordObjects = [];
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    // alert(this.$t('CheckDeviceTest.FailedToRetrieveRecords')+ error.message);
                });
        },
        //查詢設備紀錄
        async SaveEntryRoomDeviceTestingResult() {
            this.showLoading = true;
            const api = `${process.env.APIPATH}/api/Student/SaveEntryRoomDeviceTestingResult`;
            // const headers = {"Authorization": 'Bearer '+this.Token};

            var AudioDeviceName = null;
            var MicrophoneDeviceName = null;
            var CameraDeviceName = null;

            if (this.audioCheck) {
                AudioDeviceName = this.s_speaker;
            }
            else 
            {
                if (this.agoraPlaybackDevicesList.length != 0) {
                    AudioDeviceName = this.agoraPlaybackDevicesList[0].label
                }
            }

            if (this.micCheck) {
                MicrophoneDeviceName = this.s_mic;
            }
            else 
            {
                if (this.agoraMicrophoneList.length != 0) 
                {
                    MicrophoneDeviceName = this.agoraMicrophoneList[0].label
                }
            }

            if (this.cameraCheck) 
            {
                CameraDeviceName = this.s_camera;
            }
            else 
            {
                if (this.agoraCamerasList.length != 0) 
                {
                    CameraDeviceName = this.agoraCamerasList[0].label
                }
            }

            const inputdata =
            {
                // UserId: this.GLOBAL.StudentUserId
                // Model:this.Model,

                "UserId": sessionStorage.getItem('StudentUserId'),
                "ClassroomId": sessionStorage.getItem('ClassroomId'),
                "PreClassDeviceTestingId": this.PreClassDeviceTestingId,
                "AudioDeviceName": AudioDeviceName,
                "AudioDevicePassed": this.audioCheck,
                "MicrophoneDeviceName": MicrophoneDeviceName,
                "MicrophoneDevicePassed": this.micCheck,
                "CameraDeviceName": CameraDeviceName,
                "CameraDevicePassed": this.cameraCheck,
                "Model": this.Model,
                "ModelPassed": this.modelCheck,
                "Browser": this.Browser,
                "BrowserPassed": this.browserCheck,
                "IsPassed": this.IsPassed,
            };

            await axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if (response.data.Result) {
                        console.log('response', response);
                        if (this.IsPassed) {
                            if (sessionStorage.getItem('ClassroomUrl') != null) {
                                window.open(sessionStorage.getItem('ClassroomUrl'), '_self');
                            }
                        }
                    } else {
                        //
                    }
                })
                .catch(error => {
                    // this.RecordObjects = [];
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    // alert(this.$t('CheckDeviceTest.FailedToRetrieveRecords')+ error.message);
                });
        },
        async CheckDeiveAndAgora() {
            var modelErrorMessage = '';
            var browserErrorMessage = '';
            var micErrorMessage = '';
            var cameraErrorMessage = '';
            var audioErrorMessage = '';

            for (var index in this.PreClassDeviceTesting) {
                if (this.PreClassDeviceTesting.hasOwnProperty(index)) {
                    var item = this.PreClassDeviceTesting[index];
                }
                console.log('PreClassDeviceTesting', this.PreClassDeviceTesting)
                console.log('PreClassDeviceTesting-item', item)
                this.s_camera = item.CameraDeviceName;
                this.s_mic = item.MicrophoneDeviceName;
                //增加手機與Ipad判斷
                if (this.Model == 'desktop') { this.s_speaker = item.AudioDeviceName; }
                else { this.s_speaker = item.MicrophoneDeviceName; }

                this.modelCheck = this.Model == item.Model;
                this.browserCheck = this.Browser == item.Browser;
                this.micCheck = this.checkList(this.agoraMicrophoneList, this.s_mic);
                this.cameraCheck = this.checkList(this.agoraCamerasList, this.s_camera);
                this.audioCheck = this.checkList(this.agoraPlaybackDevicesList, this.s_speaker);

                console.log('micCheck', this.micCheck)
                console.log('cameraCheck', this.cameraCheck)
                console.log('audioCheck', this.audioCheck)

                modelErrorMessage += item.Model;
                browserErrorMessage += item.Browser;
                micErrorMessage += item.MicrophoneDeviceName;
                audioErrorMessage += item.AudioDeviceName;
                cameraErrorMessage += item.CameraDeviceName;

                if (this.micCheck && this.audioCheck) {
                    this.PreClassDeviceTestingId = item.PreClassDeviceTestingId;
                    break;
                }
            }
            // this.PreClassDeviceTesting.some(item =>{

            //     console.log('PreClassDeviceTesting',this.PreClassDeviceTesting)
            //     console.log('PreClassDeviceTesting-item',item)
            //     this.s_camera= item.CameraDeviceName;
            //     this.s_mic= item.MicrophoneDeviceName;
            //     //增加手機與Ipad判斷
            //     if(this.Model == 'desktop'){this.s_speaker = item.AudioDeviceName;}
            //     else{this.s_speaker = item.MicrophoneDeviceName;}

            //     this.modelCheck = this.Model == item.Model;
            //     this.browserCheck = this.Browser == item.Browser;
            //     this.micCheck = this.checkList(this.agoraMicrophoneList,this.s_mic);
            //     this.cameraCheck = this.checkList(this.agoraCamerasList,this.s_camera);
            //     this.audioCheck = this.checkList(this.agoraPlaybackDevicesList,this.s_speaker);

            //     console.log('micCheck',this.micCheck)
            //     console.log('cameraCheck',this.cameraCheck)
            //     console.log('audioCheck',this.audioCheck)

            //     modelErrorMessage += item.Model;
            //     browserErrorMessage += item.Browser;
            //     micErrorMessage += item.MicrophoneDeviceName;
            //     audioErrorMessage += item.AudioDeviceName;
            //     cameraErrorMessage += item.CameraDeviceName;

            //     if(this.micCheck && this.audioCheck){
            //         this.PreClassDeviceTestingId = item.PreClassDeviceTestingId;
            //         return;
            //     }
            // });

            if (!this.modelCheck) {
                this.RecordObjects[0].Model = [true, ['fasl', 'xmark'], '#ff0000']
                //錯誤訊息
                this.RecordObjects[1].Model = [false, '原設備：' + modelErrorMessage + '    目前設備：' + this.Model]
            }
            else {
                this.RecordObjects[0].Model = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.RecordObjects[1].Model = [false, '-']
            }

            if (!this.browserCheck) {
                this.RecordObjects[0].Browser = [true, ['fasl', 'xmark'], '#ff0000']
                //錯誤訊息
                this.RecordObjects[1].Browser = [false, '原設備：' + browserErrorMessage + '    目前設備：' + this.Browser]
            }
            else {
                this.RecordObjects[0].Browser = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.RecordObjects[1].Browser = [false, '-']
            }

            if (!this.audioCheck) {
                var errorMessage = ``;
                this.agoraPlaybackDevicesList.forEach(element => {
                    errorMessage += element.label + "　";
                });

                this.RecordObjects[0].Audio = [true, ['fasl', 'xmark'], '#ff0000']
                //錯誤訊息
                this.RecordObjects[1].Audio = [false, '原設備：' + audioErrorMessage + '    目前設備：' + errorMessage]
            }
            else {
                this.RecordObjects[0].Audio = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.RecordObjects[1].Audio = [false, '-']
            }

            if (!this.micCheck) {
                var errorMessage = ``;
                this.agoraMicrophoneList.forEach(element => {
                    errorMessage += element.label + "　";
                });
                this.RecordObjects[0].Mic = [true, ['fasl', 'xmark'], '#ff0000']
                //錯誤訊息
                this.RecordObjects[1].Mic = [false, '原設備：' + micErrorMessage + '    目前設備：' + errorMessage]
            }
            else {
                this.RecordObjects[0].Mic = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.RecordObjects[1].Mic = [false, '-']
            }

            if (!this.cameraCheck) {
                this.RecordObjects[0].Camera = [false, '-']
                //錯誤訊息
                //this.RecordObjects[1].Camera = [false,'原設備：'+ this.PreClassDeviceTesting.CameraDeviceName+'    目前設備：'+this.agoraCamerasList]
                this.RecordObjects[1].Camera = [false, '-']
            }
            else {
                this.RecordObjects[0].Camera = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.RecordObjects[1].Camera = [false, '-']
            }

            if (this.modelCheck && this.browserCheck && this.audioCheck && this.micCheck) {
                this.IsPassed = true;
                this.showEnterClassroom = true;
                this.CheckResult = this.$t('CheckDeviceTest.Pass')
            }
            else 
            {
                this.IsPassed = false;
                this.showEnterClassroom = false;
                this.RecordObjects[0].Model = [true, 'fa-sharp fa-light fa-check', '#49f500']
                this.Message = '更換設備後，請重新驗證，若仍無法進入請與補習班負責人員聯繫，謝謝！'
                $('#ShowMessageModal').modal('show');
            }

            if (this.PreClassDeviceTestingId == 0) 
            {
                this.PreClassDeviceTestingId = this.PreClassDeviceTesting.pop().PreClassDeviceTestingId;
            }

            await this.SaveEntryRoomDeviceTestingResult();
        },
        checkList(list, checkValue) 
        {
            let b = false;
            for (var f = 0; f < list.length; f++) {
                if (list[f].label == checkValue) {
                    b = true;
                }
            }
            return b;
        },
        deviceType() {
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        },
        browserVersionType() {
            var nAgt = navigator.userAgent;

            var testIsChrome = /CriOS/i.test(navigator.userAgent);

            if (testIsChrome) {
                this.browser = 'Chrome';
                return this.browser;
            }

            var verOffset = '';
            // var version = '';
            // Opera
            if ((verOffset = nAgt.indexOf('Opera')) != -1) {
                this.browser = 'Opera';
                this.NowBrowserVersion = nAgt.substring(verOffset + 6, verOffset + 6 + (nAgt.substring(verOffset + 6)).indexOf(' '));
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    this.NowBrowserVersion = nAgt.substring(verOffset + 8, verOffset + 8 + (nAgt.substring(verOffset + 8)).indexOf(' '));
                }
            }
            // Opera Next
            if ((verOffset = nAgt.indexOf('OPR')) != -1) {
                this.browser = 'Opera';
                this.NowBrowserVersion = nAgt.substring(verOffset + 4, verOffset + 4 + (nAgt.substring(verOffset + 4)).indexOf(' '));
            }
            // Legacy Edge
            else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
                this.browser = 'Microsoft Legacy Edge';
                this.NowBrowserVersion = nAgt.substring(verOffset + 5, verOffset + 5 + (nAgt.substring(verOffset + 5)).indexOf(' '));
            }
            // Edge (Chromium)
            else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
                this.browser = 'Microsoft Edge';
                this.NowBrowserVersion = nAgt.substring(verOffset + 4, verOffset + 4 + (nAgt.substring(verOffset + 4)).indexOf(' '));
            }
            // MSIE
            else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
                this.browser = 'Microsoft Internet Explorer';
                this.NowBrowserVersion = nAgt.substring(verOffset + 5, verOffset + 5 + (nAgt.substring(verOffset + 5)).indexOf(' '));
            }
            // Chrome
            else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
                this.browser = 'Chrome';
                this.NowBrowserVersion = nAgt.substring(verOffset + 7, verOffset + 7 + (nAgt.substring(verOffset + 7)).indexOf(' '));
            }
            // Safari
            else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
                this.browser = 'Safari';
                this.NowBrowserVersion = nAgt.substring(verOffset + 7, verOffset + 7 + (nAgt.substring(verOffset + 7)).indexOf(' '));
                if ((verOffset = nAgt.indexOf('Version')) != -1) {
                    this.NowBrowserVersion = nAgt.substring(verOffset + 8, verOffset + 8 + (nAgt.substring(verOffset + 8)).indexOf(' '));
                }
            }
            // Firefox
            else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
                this.browser = 'Firefox';
                this.NowBrowserVersion = nAgt.substring(verOffset + 8, verOffset + 8 + (nAgt.substring(verOffset + 8)).indexOf(' '));
            }
            // MSIE 11+
            else if (nAgt.indexOf('Trident/') != -1) {
                this.browser = 'Microsoft Internet Explorer';
                this.NowBrowserVersion = nAgt.substring(nAgt.indexOf('rv:') + 3, nAgt.indexOf('rv:') + 3 + (nAgt.substring(nAgt.indexOf('rv:') + 3)).indexOf(' '));
            }
            // Other this.browsers
            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                this.browser = nAgt.substring(nameOffset, verOffset);
                this.NowBrowserVersion = nAgt.substring(verOffset + 1, verOffset + 1 + (nAgt.substring(verOffset + 1)).indexOf(' '));
                if (this.browser.toLowerCase() == this.browser.toUpperCase()) {
                    this.browser = navigator.appName;
                }
            }
            return this.browser;
        },
        async ReEnter() {
            this.GetReEnterUrl();
        },
        async ReCheck() {
            // await this.GetPreClassDeviceTesting();
            // await this.CheckDeiveAndAgora();
            location.reload()
        },
        DeviceTest() {
            //設備檢測
            //判斷學生是否是台大明明(1099)的學生，如果是導向TP DeviceTest
            //99999 = 老師身份
            if (sessionStorage.getItem('CustomerCode') == 1099 || sessionStorage.getItem('CustomerCode') == 99999) {
                var baseUserId = btoa(sessionStorage.getItem('StudentUserId'))
                //導向TP DeviceTest
                window.open(`${process.env.TEACHINGPLATFORM}` + 'NewTeachingPlatform/deviceTest?UserId=' + baseUserId, '_blank');
            }
            else {
                this.$router.push({
                    name: 'deviceTest',
                    params: {
                        IsSpeedTest: this.$route.params.IsSpeedTest,
                        ClassroomUrl: sessionStorage.getItem('ClassroomUrl'),
                    }
                });
            }
        },
        EnterClassroom() {
            window.open(sessionStorage.getItem('ClassroomUrl'), '_blank');
        },
        async agoraLeave() {
            await this.agoraClient.leave();
        },
        async GetEbSeq() {
            this.showLoading = true;
            const api = `${process.env.APIPATH}/api/Student/GetEpsMbr`;
            const inputdata =
            {
                UserId: sessionStorage.getItem('StudentUserId'),
            };

            await axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if (response.data.Result) {
                        console.log('response', response);
                        console.log('EBSEQ', response.data.EBSEQ); 
                        this.ebseq = response.data.EBSEQ;
                        sessionStorage.setItem('CustomerCode', this.ebseq)
                    } else {

                    }
                })
                .catch(error => {
                    // this.RecordObjects = [];
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("取得失敗：" + error.message);
                });
        },
        async GetClassroomUrlByStudnet() {
            this.showLoading = true;
            const api = `${process.env.APIPATH}/api/Student/GetClassroomUrlByStudnet`;
            const inputdata =
            {
                UserId: sessionStorage.getItem('StudentUserId'),
                ClassroomId: sessionStorage.getItem('ClassroomId'),
            };

            await axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if (response.data.Result) {
                        console.log('response', response);
                        console.log('ClassroomUrl', response.data.ClassroomUrl);
                        this.classroomUrl = response.data.ClassroomUrl;
                        sessionStorage.setItem('ClassroomUrl', this.classroomUrl)
                    } else {

                    }
                })
                .catch(error => {
                    // this.RecordObjects = [];
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                    alert("取得失敗：" + error.message);
                });
        },
        GetReEnterUrl() {
            const api = `${process.env.APIPATH}/api/Student/GetClassroomUrl`;
            const inputdata =
            {
                UserId: sessionStorage.getItem('StudentUserId'),
                ClassroomId: sessionStorage.getItem('ClassroomId')
            };

            axios.post(api, inputdata)
                .then((response) => {
                    console.log('GetReEnterUrl', response)
                    if (response.data.Result) {
                        window.open(response.data.ClassroomUrl, '_self');
                    }
                })
                .catch(error => {
                    console.error("There was an error!", error);
                    alert("取得失敗：" + error.message);
                });
        }
    },
    created() {
        this.Model = this.deviceType();
        this.Browser = this.browserVersionType();
        this.Language = this.$t('lang');

        if (sessionStorage.getItem('ClassroomId') == null) {
            sessionStorage.setItem('ClassroomId', this.$route.query.ClassroomId);
        }
        if (sessionStorage.getItem('StudentUserId') == null) {
            sessionStorage.setItem('StudentUserId', this.$route.query.UserId);
        }

        if (this.Model == 'desktop') { this.isDesktop = true };

        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === 'visible') {
                // 在從其他頁面切換回本頁時執行的程式碼
                //console.log("切換回本頁");
                location.reload()
            }
        });
    },
    beforeDestroy() {
        // 頁面銷毀時 離開agora
        this.agoraLeave();
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/CheckDeviceTest.vue